import { useTranslation } from 'react-i18next';

const KEYS = ['accreditationBar.iso9001', 'accreditationBar.iso45001', 'accreditationBar.iso14001'];

export default function AccreditationBar({ glass = false }: { glass?: boolean }) {
  const { t } = useTranslation();
  const labels = KEYS.map(key => t(key)).filter(Boolean);
  if (labels.length === 0) return null;
  return (
    <section className={`accreditation-bar${glass ? ' accreditation-bar--glass' : ''}`}>
      <div className="container">
        <div className="accreditation-bar-grid">
          {labels.map((label, i) => (
            <div className="accreditation-bar-item" key={i}>
              <i className="fa-solid fa-certificate" aria-hidden="true" />
              <span>{label}</span>
            </div>
          ))}
        </div>
        {t('accreditationBar.caption') && (
          <p className="accreditation-bar-caption">{t('accreditationBar.caption')}</p>
        )}
      </div>
    </section>
  );
}
